// extracted by mini-css-extract-plugin
module.exports = {"tabs":"index_tabs_3s8bm","current":"index_current_18l-y","badge":"index_badge_31OSp"};